import { useState } from 'react'
import { Edit, Check, Close } from '@mui/icons-material'
import { useGetAllBusinesses } from '../../../api/routes/businesses'
import { useUpdateDevice } from '../../../api/routes/devices'

type BusinessEditorProps = {
    deviceId: string
    business: { id: string; name: string } | null
}

const BusinessEditor = ({ deviceId, business }: BusinessEditorProps) => {
    const { data: businesses } = useGetAllBusinesses()
    const updateDevice = useUpdateDevice()
    const [isEditing, setIsEditing] = useState(false)
    const [selectedBusinessId, setSelectedBusinessId] = useState('')

    return (
        <div className="space-y-1">
            <dt className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                Business
            </dt>
            <dd className="text-sm text-foreground flex items-center gap-2">
                {isEditing ? (
                    <div className="flex items-center gap-2 flex-1">
                        <select
                            value={selectedBusinessId}
                            onChange={(e) =>
                                setSelectedBusinessId(e.target.value)
                            }
                            className="flex-1 h-8 rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-1 focus:ring-ring"
                        >
                            {businesses?.map((b: any) => (
                                <option key={b.id} value={b.id}>
                                    {b.name}
                                </option>
                            ))}
                        </select>
                        <button
                            className="p-1 rounded-md hover:bg-accent text-green-600 transition-colors"
                            onClick={() => {
                                updateDevice.mutate({
                                    id: deviceId,
                                    data: {
                                        business: selectedBusinessId,
                                    },
                                })
                                setIsEditing(false)
                            }}
                        >
                            <Check style={{ fontSize: 18 }} />
                        </button>
                        <button
                            className="p-1 rounded-md hover:bg-accent text-muted-foreground transition-colors"
                            onClick={() => setIsEditing(false)}
                        >
                            <Close style={{ fontSize: 18 }} />
                        </button>
                    </div>
                ) : (
                    <>
                        <span>{business?.name}</span>
                        <button
                            className="p-1 rounded-md hover:bg-accent text-muted-foreground hover:text-foreground transition-colors"
                            onClick={() => {
                                setSelectedBusinessId(business?.id || '')
                                setIsEditing(true)
                            }}
                        >
                            <Edit style={{ fontSize: 14 }} />
                        </button>
                    </>
                )}
            </dd>
        </div>
    )
}

export default BusinessEditor